<template>
  <div class="country-configuration">
    <ExBreadcrumbs :breadcrumbsList="breadcrumbItems" />
    <OperatingCountryTab
      :countries="countryList"
      :data-source="countryList"
      :server-side-pagination="true"
      :external-total="countryListTotal"
      :total-count="countryListTotal"
      :synced-search-query="countrySearchQuery"
      :chatter-list="chatterList"
      :total-checkpoint-chatter="totalCountryChatter"
      :dropdown-country-list="dropdownCountryList"
      :operating-catalog-country-ids="operatingCatalogCountryIds"
      @get-chatter-list="getCountryChatterList($event, 1)"
      @requestMoreChatter="loadMoreChatter"
      @reloadCountryList="emit('reloadCountryList')"
      @country-page-change="emit('country-page-change', $event)"
      @country-search="emit('country-search', $event)"
      @country-status-filter="emit('country-status-filter', $event)"
      @onAddCountry="(country, search) => emit('onAddCountry', country, search)"
      @add-country-confirm="(country, search) => emit('onAddCountry', country, search)"
      @ensure-country-catalog="emit('ensure-country-catalog')"
      @set-work-hours="emit('set-work-hours', $event)"
      @menu-action="emit('menu-action', $event)"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import OperatingCountryTab from "@components/OperatingCountryTab/OperatingCountryTab.vue";
import ExBreadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import { getChatterList } from "@/api";

defineProps({
  countryList: {
    type: Array,
    required: true,
  },
  countryListTotal: {
    type: Number,
    default: 0,
  },
  countrySearchQuery: {
    type: String,
    default: "",
  },
  dropdownCountryList: {
    type: Array,
    required: false,
    default: () => [],
  },
  operatingCatalogCountryIds: {
    type: Array,
    required: false,
    default: () => [],
  },
});

const chatterList = ref([]);
const totalCountryChatter = ref(0);
const currentCountryData = ref(null);
const isLoadingChatter = ref(false);

const emit = defineEmits([
  "reloadCountryList",
  "onAddCountry",
  "fetchOperatingCountry",
  "ensure-country-catalog",
  "country-page-change",
  "country-search",
  "country-status-filter",
  "set-work-hours",
  "menu-action",
]);

const breadcrumbItems = [
  { text: "Configuration", href: "/settings/configuration", disabled: false },
  { text: "Countries", disabled: true },
];

const chatterPage = computed(() => {
  return Math.ceil(chatterList.value.length / 10) || 0;
});

const getCountryChatterList = async (item, page) => {
  try {
    isLoadingChatter.value = true;
    const accountId = JSON.parse(localStorage.getItem("currentAccountID"));

    if (page === 1) {
      currentCountryData.value = item;
      chatterList.value = [];
    }

    const { data } = await getChatterList(accountId, item.id, "operatingcountry", page);

    if (data && data.count !== undefined) {
      totalCountryChatter.value = data.count;
    }

    if (data && data.results && Array.isArray(data.results)) {
      const chatterItems = data.results.map((el) => {
        const date = new Date(el.recorded_on);
        const milliseconds = date.getTime();
        const millisecondsString = milliseconds.toString();
        const nameParts = el.recorded_by_name.split(" ");
        const newEl = {};
        newEl.id = el.id;

        if (nameParts.length === 2) {
          newEl.avatar = {
            picture: "",
            firstName: nameParts[0],
            lastName: nameParts[1],
          };
        } else {
          newEl.avatar = {
            picture: "",
            firstName: el.recorded_by_name,
            lastName: "",
          };
        }

        newEl.IsExIQtiveBot = false;
        newEl.message = truncateHtml(el.note);
        newEl.created_on = millisecondsString;
        newEl.IsHistory = el.is_history;
        return newEl;
      });

      chatterList.value.push(...chatterItems);
    }
  } catch (error) {
    console.error("Error fetching chatter list:", error);
  } finally {
    isLoadingChatter.value = false;
  }
};

const loadMoreChatter = async () => {
  if (isLoadingChatter.value) {
    return;
  }

  if (chatterList.value.length >= totalCountryChatter.value) {
    return;
  }

  if (currentCountryData.value) {
    const nextPage = chatterPage.value + 1;
    await getCountryChatterList(currentCountryData.value, nextPage);
  }
};

const truncateHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};
</script>

<style scoped>
.country-configuration {
  width: 100%;
}
</style>
